// In NCS-4079 we renamed the Average Idle Noise dashlet, requiring a prefs migration to the new name.
import PrefsService from "../services/PrefsService"

export default function migration2 () {
    function idleNoiseMigration(prefKey) {
        let prefs = JSON.parse(PrefsService.get(prefKey, '{}'));
    
        for (let key in prefs) {
            if (prefs[key] instanceof Object && 'dashlets' in prefs[key]) {
                let dashlets = prefs[key]['dashlets'];
                for (let dashlet of dashlets) {
                    if (dashlet.value === "avgIdleNoise") {
                        dashlet.name = 'tower.db.btsIdleNoise'
                        dashlet.value = 'btsIdleNoise'
                        dashlet.i = dashlet.i.replace('avgIdleNoise', 'btsIdleNoise')
                    }
                }
            }
        }
        PrefsService.put(prefKey, JSON.stringify(prefs))
    }
    idleNoiseMigration('systemDashboard')
    idleNoiseMigration('baseStationDetailsDashboard')
}